//src/App.js
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import About from './components/About';
import AllProperties from './components/AllProperties';
import AuthExpiryWatcher from './components/AuthExpiryWatcher';
import BlogList from './components/BlogList';
import BlogDetail from './components/BlogDetail';
import CategorySection from './components/CategorySection';
import Contact from './components/Contact';
import DashboardLayout from './components/dashboard/DashboardLayout';
import DashboardProperties from './components/dashboard/DashboardProperties';
import DashboardSummary from './components/dashboard/DashboardSummary';
import OwnerDashboard from './components/dashboard/OwnerDashboard';
import EditProperty from './components/EditProperty';
import Footer from './components/Footer';
import ForgotPassword from './components/forgot-password/ForgotPassword';
import ResetPassword from './components/forgot-password/ResetPassword';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import DetailProperty from './components/property-detail/DetailProperty';
import DashboardPropertyDetail from './components/dashboard/PropertyDetail';
import PropertyList from './components/PropertyList';
import ProtectedRoute from './components/ProtectedRoute';
import SellProperty from './components/SellProperty';
import SponsoredBannerSection from './components/SponsoredBannerSection';
import VerifyOTP from './components/VerifyOTP';
import { DashboardProvider } from './contexts/DashboardContext';
import Login from './features/auth/Login';
import Register from './features/auth/register/Register';
import NotificationsPage from './pages/dashboard/NotificationsPage';
import ProfilePage from './pages/dashboard/Profile';
import InspectionRequest from './pages/inspection/InspectionRequest';
import SubscriptionCheckoutPage from './pages/subscription-plans/SubscriptionCheckoutPage';
import SubscriptionPlansPage from './pages/subscription-plans/SubscriptionPlansPage';

const HomePage = () => (
    <>
        <HeroSection />
        <SponsoredBannerSection />
        <CategorySection />
        <PropertyList showAllLink />

        <About />
        {/* <OurService /> */}
        <Contact />
    </>
);

const AppShell = () => {
    const location = useLocation();
    const isDashboardRoute = location.pathname.startsWith('/dashboard');

    return (
        <>
            <AuthExpiryWatcher />
            {!isDashboardRoute && <Header />}
            <main className={isDashboardRoute ? '' : 'main-content'}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/all-properties" element={<AllProperties />} />
                    <Route path="/properties" element={<PropertyList />} />
                    <Route path="/properties/:slug" element={<DetailProperty />} />
                    <Route path="/blog" element={<BlogList />} />
                    <Route path="/blog/:slug" element={<BlogDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    {/* <Route path="/our-service" element={<OurService />} /> */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/verify-otp" element={<VerifyOTP />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />

                    <Route
                        path="/sell-property"
                        element={
                            <ProtectedRoute>
                                <SellProperty />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <DashboardProvider>
                                    <DashboardLayout />
                                </DashboardProvider>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<OwnerDashboard />} />
                        <Route path="summary" element={<DashboardSummary />} />
                        <Route path="profile" element={<ProfilePage />} />
                        <Route path="properties/create" element={<SellProperty />} />
                        <Route path="properties/:identifier/edit" element={<EditProperty />} />
                        <Route path="properties/:identifier" element={<DashboardPropertyDetail />} />
        <Route path="properties" element={<DashboardProperties />} />
                        <Route path="notifications" element={<NotificationsPage />} />
                        <Route path="subscription-plans" element={<SubscriptionPlansPage />} />
                        <Route path="subscription/checkout" element={<SubscriptionCheckoutPage />} />
                        <Route path="properties/:propertyId/inspection-request" element={<InspectionRequest />} />
                    </Route>

                    <Route
                        path="*"
                        element={
                            <div style={{ padding: '40px', textAlign: 'center' }}>
                                <h2>404 - Halaman tidak ditemukan</h2>
                            </div>
                        }
                    />
                </Routes>
            </main>

            {!isDashboardRoute && <Footer />}
        </>
    );
};

const App = () => {
    return (
        <HelmetProvider>
            <Router>
                <AppShell />
            </Router>
        </HelmetProvider>
    );
};

export default App;
